import { apis } from '../api/apis';

export function useApiSelector() {
	return apis;
};
